import { Photo } from 'records/Photo';
import GQLRequest from 'utils/GQLRequest';

interface RawPhotoFile {
  fileid: string;
  projectid: string;
  filename: string;
  filesize: number;
  category: string;
  extension: string;
  uploadStatus: string;
}

export const getPhoto = async (
  projectid: string,
  fileid: string
): Promise<Photo> => {
  try {
    const {
      fileUrl: { file, url },
    } = await new GQLRequest()
      .query(
        `
        query FileUrl($projectFile: ProjectFile) {
          fileUrl(input: $projectFile) {
            file {
              fileid
              projectid
              filename
              filesize
              category
              extension
              uploadStatus
            }
            url
          }
        }
        `
      )
      .variables({ projectFile: { fileid, projectid } })
      .json<{ fileUrl: { file: RawPhotoFile; url: string } }>();

    return Photo.deserialize({
      ...file,
      url,
    });
  } catch (err) {
    console.log('getPhoto', err);

    throw err;
  }
};

export default {
  getPhoto,
};
